import React from 'react';
import CalendarPageContent from "../components/calendarPageContent/index"

const Calendar = () =>{
    return(
        <CalendarPageContent/>
    );
}

export default Calendar; 